export const apiEndPoint = "https://us-central1-vegamta-dev.cloudfunctions.net";
